import { LogOut, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import ConfigurationModal from '@/components/configuration-modal';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { SheetClose, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import useLogout from '@/hooks/use-logout';
import useRoleAccess from '@/hooks/use-role-access';

export function Sidepanel() {
  const { t } = useTranslation();
  const { mutate: logout, isPending, isSuccess } = useLogout();
  const { isAdActive } = useRoleAccess();

  const isSigningOut = isPending || isSuccess;

  const handleLogout = () => {
    logout();
  };

  return (
    <SheetContent
      id="sidepanel-sheet"
      side="right"
      showCloseButton={false}
      className="w-full gap-0 border-0 p-0 sm:max-w-86"
    >
      <SheetHeader className="bg-primary flex h-17 flex-row items-center justify-between gap-0 space-y-0 border-b border-white/20 px-5 text-left">
        <SheetTitle className="text-lg font-bold tracking-wide text-white">
          {t('common:appMenu.title')}
        </SheetTitle>

        <SheetClose asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="-mr-3 text-white hover:bg-white/10 hover:text-white hover:opacity-90"
            aria-label="Close menu"
          >
            <X className="h-5 w-5" />
          </Button>
        </SheetClose>
      </SheetHeader>

      <div className="bg-background px-0 py-2">
        <nav className="flex flex-col gap-2">
          {isAdActive && (
            <>
              <div className="hover:bg-muted">
                <ConfigurationModal />
              </div>
              <Separator className="bg-border mx-5" />
            </>
          )}
          <div className="hover:bg-muted">
            <Button
              type="button"
              variant="ghost"
              disabled={isSigningOut}
              onClick={handleLogout}
              className="text-foreground h-12 w-full justify-start gap-3 px-5 font-medium tracking-normal transition-colors"
            >
              <LogOut className="text-foreground h-5 w-5" strokeWidth={2} />
              <span className="font-medium">{t('common:appMenu.signout')}</span>
            </Button>
          </div>
        </nav>
      </div>
    </SheetContent>
  );
}
